import { useEffect, useState } from "react";
import MiniDrawer from "../../component/Layout1";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import RestoreIcon from "@mui/icons-material/Restore";
import {
  createPatrikaPdf,
  deletePatrikaFile,
  getAllPatrikaRequest,
  getRemovedUsersAPI,
  restoreUserAPI,
  updatePatrikaFile,
} from "../../api/auth";
import CustomButon from "../../component/Button";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomDialog from "../../component/dailog/dailog";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileUpload from "../../component/upload/fileUpload";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Patrika = () => {
  const [dialog, setDialog] = useState(false);
  const [title, setTitle] = useState("");
  const [blobData, setBlobData] = useState(null);
  const [patrikaData, setPatrikaData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedpatrikaId, setSelectedpatrikaId] = useState(null);


  const handleInputChange = (e) => {
    setTitle(e.target.value);
  };

  const onSubmit = async () => {
    const formData = new FormData();
    formData.append("file", blobData, title); // `title` should be a filename string

    try {
      const response = await createPatrikaPdf(formData);
      const data = await response.json();
      console.log(data)
    } catch (error) {
      console.error("Upload error:", error);
    }
  };
  
  console.log("form data", patrikaData)

  const handleEdit = (patrika) => {
    setTitle(patrika.title);
    setBlobData(patrika.link)
    setSelectedpatrikaId(patrika._id);
    setDialog(true);
  };

  const resetForm = () => {
    setTitle("");
    setBlobData(null);
    setSelectedpatrikaId(null);
  };

  const updatePatrika = async (id, formData) => {
    try {
      const formFileData = new FormData();
      formFileData.append("file", formData, title);
      const resp = await updatePatrikaFile(id, formFileData);
      if (resp.remote === "success") {
        getAllPatrika();
        resetForm();
      }
    }
    catch (error) {
      console.log('error.........', error);
    }
  };

  useEffect(() => {
    getAllPatrika();
  }, [title,blobData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (id) => {
    setSelectedpatrikaId(id)
    setOpen(true);
  };

  const getAllPatrika = async () => {
    const resp = await getAllPatrikaRequest();
    if (resp.remote === "success") {
      setPatrikaData(resp.data.data);
    }
  };

  const handleDelete = async (id) => {
    const resp = await deletePatrikaFile(id);
    if (resp.remote === "success") {
      setOpen(false);
      getAllPatrika();
    }
  };

  return (
    <MiniDrawer>
      <Box>
        <Box
          sx={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
            Patrika
          </Typography>
          <CustomButon onClick={() => setDialog(true)} variant="contained">
            Add
          </CustomButon>
        </Box>
        <Box className="FormBox" mb={3}>
          <TableContainer component={Paper}>
            <Table className="translation-table">
              <TableHead>
                <TableRow>
                  <TableCell>S.no.</TableCell>
                  <TableCell>Document</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {patrikaData.map((el, index) => (
                  <TableRow key={el._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <a
                        href={`${process.env.REACT_APP_BASE_URL}/${el.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {el.title}
                      </a>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Link
                          onClick={() => handleEdit(el)}
                          className="btnLink"
                          style={{ background: "#CFFFE2", padding: "5px", borderRadius: "5px" }}
                        >
                          <EditIcon style={{ color: "#00BE4C" }} />
                        </Link>

                        <Link

                          onClick={() => handleClickOpen(el._id)}

                          className="btnLink"
                          style={{ background: "#FFDCDC", padding: "5px", borderRadius: "5px" }}
                        >
                          <DeleteIcon style={{ color: "#FF0000" }} />
                        </Link>
                        <Dialog open={open} onClose={handleClose}>
                          <DialogContent>
                            <Typography
                              style={{
                                fontWeight: 500,
                                fontSize: "18.51px",
                                lineHeight: "20.36px",
                              }}
                            >
                              Do you really want to remove the user?
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleDelete(selectedpatrikaId)}
                              color="error"
                            >
                              Remove
                            </Button>
                          </DialogActions>
                        </Dialog>

                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <CustomDialog
            open={dialog}
            onSave={() => {
              if (selectedpatrikaId) {
                updatePatrika(selectedpatrikaId,blobData);
              } else {
                onSubmit();
              }
             setDialog(false);
                resetForm();
                getAllPatrika()
              }}
              onClose={() => {
                setDialog(false);
                resetForm();
              }}
            >
            <form>
              <Grid
                container
                spacing={2}
                sx={{
                  "& input": {
                    width: "100%",
                    padding: "10px ",
                    borderRadius: "5px",
                  },
                }}
              >
                <Grid item md={12}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Title"
                    name="title"
                    value={title}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item md={12}>
                  <FileUpload value={(value) => setBlobData(value)} />
                </Grid>
              </Grid>
            </form>
          </CustomDialog>
        </Box>
      </Box>
    </MiniDrawer>
  );
};

export default Patrika;

//   const handleInputChange = (e) => {
//     setTitle(e.target.value)


//             onClose={resetForm}
//           >
//             <form>
//               <Grid
//                 container
//                 spacing={2}
//                 sx={{
//                   "& input": {
//                     width: "100%",
//                     padding: "10px",
//                     borderRadius: "5px",
//                   },
//                 }}
//               >
//                 <Grid item md={12}>
//                   <input
//                     type="text"
//                     placeholder="Title"
//                     name="title"
//                     value={title}
//                     onChange={handleInputChange}
//                   />
//                 </Grid>
//                 <Grid item md={12}>
//                   <FileUpload value={(value) => setBlobData(value)} />
//                 </Grid>
//               </Grid>
//             </form>
//           </CustomDialog>
//         </Box>
//       </Box>
//     </MiniDrawer>
//   );
// };

// export default Patrika;
